// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__9prmK","emails":"CreateEditClinics_emails__a7Kyu","emailTagLabel":"CreateEditClinics_emailTagLabel__3QFfq"};